import { useEffect, useState } from "react";

const QUERY = "(max-width: 991.98px)";

/** Vista &lt; lg: drawer móvil del sidebar; las etiquetas deben mostrarse aunque collapseSideBar sea true */
export function useBreakpointBelowLg(): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const sync = () => setMatches(mq.matches);
    sync();
    mq.addEventListener("change", sync);
    return () => mq.removeEventListener("change", sync);
  }, []);

  return matches;
}
